export default __webpack_public_path__ + "media/images/back-to-top-icon-3950aa666ee8b546d53d088d12b05f9e.svg";